import React, { useEffect } from 'react';
import { Content, FlexboxGrid, Grid } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import FlowPageLayout from '../../components/layout/FlowPageLayout';
import { useDispatch, useSelector } from 'react-redux';
import { selectConfigExpressApplyRequirements } from '../../store/slices/config/configSelectors';
import usePlaceNavigate from '../../hooks/usePlaceNavigate';
import { resetApplyState } from '../../store/slices/apply/applySlice';
import { FLOWS_ENUM } from '../../common/enums';
import RequirementsList from '../../components/common/RequirementsList';

const ApplyRequirements = () => {
  const dispatch = useDispatch();
  const placeNavigate = usePlaceNavigate();
  const selectedRequirements = useSelector(
    selectConfigExpressApplyRequirements
  );

  useEffect(() => {
    dispatch(resetApplyState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={FLOWS_ENUM.APPLY_LICENSE} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content>
          <FlowPageLayout
            title="Requirements"
            onBack={() => {
              dispatch(resetApplyState());
              placeNavigate('/dashboard');
            }}
          >
            <Grid
              className="mt-12 ml-0"
              fluid
            >
              <RequirementsList requirements={selectedRequirements} />
            </Grid>
          </FlowPageLayout>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default ApplyRequirements;
